import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../../services/auth/authentication.service';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { VerificationCodeDirective } from '../../../../directives/verification-code.directive';
import { QrCodeResponse } from '../../../../responses/qr-code-response';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-verification-code',
  imports: [CommonModule, ReactiveFormsModule, VerificationCodeDirective],
  templateUrl: './verification-code.component.html',
  styleUrl: './verification-code.component.scss'
})
export class VerificationCodeComponent {

  form!: FormGroup;

  @Input()
  qrCodeResponse?: QrCodeResponse;

  error?: string;

  loading: boolean = false;

  constructor(private router: Router, private authService: AuthenticationService, private fb: FormBuilder){
    this.form = fb.group({
      verificationCode: fb.control('', [Validators.required, Validators.pattern(/^[0-9]{6}$/)])
    });
  }

  public verify() : void {
    let verificationCode : string = this.form.controls['verificationCode'].value;

    if(this.form.valid) {
      this.loading = true;

      this.authService.loginWithVerificationCode(verificationCode)
      .subscribe({
        next: (response: any) => {
          this.router.navigateByUrl('dashboard');
          this.loading = false;
        },
        error: (response: HttpErrorResponse) => {
          this.error = response.error.message;
          this.loading = false;
        }
      });
    } else {
      this.error = 'Invalid verification code!';
    }
  }
}
